/* hs-eslint ignored failing-rules */
/* eslint-disable no-prototype-builtins */

'use es6';

import I18n from 'I18n';
import * as PlanType from 'marketplace-ui-common/constants/pricings/PlanType';
import * as SupportSource from 'marketplace-ui-common/constants/search/SupportSource';
import memoize from 'hs-lodash/memoize';
import { getAppCategoryI18nKey } from 'marketplace-ui-apps-core/common/utils/i18n';
import * as Sync from 'marketplace-ui-apps-core/details/constants/dataSync/Sync';
import * as FilterKey from '../constants/search/FilterKey';
import * as SortField from '../constants/search/SortField';
import * as SortOrder from '../constants/search/SortOrder';
export const getPlanTypeFilterI18nKey = memoize(planType => {
  const key = (() => {
    switch (planType) {
      case PlanType.FREE:
        return 'free';
      case PlanType.MONTHLY:
        return 'monthly';
      case PlanType.YEARLY:
        return 'yearly';
      case PlanType.ONE_TIME:
        return 'oneTime';
      case PlanType.METERED:
        return 'metered';
      case PlanType.CONTACT_US:
        return 'contact_us';
      default:
        return null;
    }
  })();
  return `appMarketplace.storefront.filters.planType.items.${key}`;
});
export const getDataSyncFilterI18nKey = memoize(sync => {
  const key = (() => {
    switch (sync) {
      case Sync.INBOUND:
        return 'inbound';
      case Sync.OUTBOUND:
        return 'outbound';
      case Sync.BOTH:
        return 'both';
      default:
        return null;
    }
  })();
  return `appMarketplace.storefront.filters.sync.items.${key}`;
});
export const getSupportSourceFilterI18nKey = memoize(supportSource => {
  const key = (() => {
    switch (supportSource) {
      case SupportSource.HUBSPOT:
        return 'hubspot';
      case SupportSource.APP_PARTNER:
        return 'appPartner';
      default:
        return null;
    }
  })();
  return `appMarketplace.storefront.filters.supportSource.items.${key}`;
});
export const getFiltersHeadingI18nKey = (filters = {}) => {
  const {
    [FilterKey.CATEGORY_V2]: categoryV2
  } = filters;
  if (categoryV2.size === 1) {
    return getAppCategoryI18nKey(categoryV2.first());
  }
  return 'appMarketplace.storefront.results.resultsPage.headingText.allCategories';
};
export const getTranslatedSortText = (sortKey, sortOrder) => {
  let key = '';
  switch (sortKey) {
    case SortField.RELEVANCE:
      key = 'relevance';
      break;
    case SortField.HUB_INSTALLS:
      key = 'mostInstalled';
      break;
    case SortField.FIRST_PUBLISHED:
      key = 'newest';
      break;
    case SortField.PRICE:
      key = sortOrder === SortOrder.ASC ? 'priceLowHigh' : 'priceHighLow';
      break;
    case SortField.NAME:
      key = sortOrder === SortOrder.ASC ? 'name' : 'nameReverse';
      break;
    case null:
      key = 'mostInstalled';
      break;
    default:
      key = null;
      break;
  }
  if (key === null) {
    return null;
  }
  return I18n.text(`appMarketplace.storefront.results.sort.options.${key}`);
};